import React from "react";
import { Box, Typography, Card } from "@mui/material";
import AssignmentCard from "./AssignmentCard";

const cardWidth = 250;

const isCompletedStatus = (a) => {
  const s = String(a?.status ?? "").trim().toLowerCase();
  if (["complete", "completed", "done", "finished"].includes(s)) return true;
  if (a?.completed === true) return true;
  if (a?.isComplete === true) return true;
  if (a?.complete === true) return true;
  if (typeof a?.progress === "number" && a.progress >= 1) return true;
  if (typeof a?.percentComplete === "number" && a.percentComplete >= 100)
    return true;
  return false;
};

const isDiagnosticAssignment = (a) => {
  if (a?.testId) return true;
  if (a?.diagnosticId) return true;
  if (String(a?.source ?? "").toLowerCase() === "diagnostic") return true;
  if (String(a?.kind ?? "").toLowerCase() === "diagnostic") return true;
  if (String(a?.type ?? "").toLowerCase() === "diagnostic") return true;
  return false;
};

const AssignmentCardsRow = ({
  assignments = [],
  title = "Assignments",
  hideCompletedDiagnostics = true,
  onView,
}) => {
  const visibleAssignments = assignments.filter((a) => {
    if (a?.loading) return true;

    const diagnostic = isDiagnosticAssignment(a);
    const completed = isCompletedStatus(a);

    if (hideCompletedDiagnostics && diagnostic && completed) return false;

    return true;
  });

  return (
    <Box sx={{ mb: 6 }}>
      <Card
        sx={{
          p: 3,
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          background: "rgba(255, 255, 255, 0.9)",
          borderRadius: 3,
          minHeight: 180,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography variant="h6" fontWeight={600} mb={2}>
          {title}
        </Typography>

        {visibleAssignments.length === 0 ? (
          <Box
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography variant="body2" color="text.secondary">
              No assignments to show.
            </Typography>
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 2.5,
            }}
          >
            {visibleAssignments.map((a, idx) => (
              <Box key={a.id ?? idx} sx={{ width: cardWidth }}>
                <AssignmentCard
                  a={a}
                  simpleView={a.simpleView}
                  reviewMode={a.reviewMode}
                  onView={onView}
                />
              </Box>
            ))}
          </Box>
        )}
      </Card>
    </Box>
  );
};

export default AssignmentCardsRow;
